export class CustomerDataModel {

    customerFormModel = {
        accountName: null,
        isIndividualAccount: '1',
        notes: null,
        isCustomer: true,
        isRfqAccount: false,
        accountDetails: {
            leadSourceId: null,
            assignedTo: null,
            industryId: null,
            accountStatusId: 1
        },
        contact: {
            contactTypeId: 1, // TODO
            firstName: null,
            middleName: null,
            lastName: null,
            email: null,
            primaryPhone: null,
            primaryExt: null,
            contactNumberList: [],
            primaryCountryCode: null,
            isInternationalPhone: false
        },
        address: {
            addressLine1: null,
            addressLine2: null,
            fullAddress: null,
            city: null,
            provinceId: null,
            zipCode: null,
            countryId: null,
            addressIndicator: '1',
            customeAddressTypeInfo: null,
            addressTypeId: 1, // TODO
        },
    };

    customerEditFormModel = {
        customerId: null,
        accountName: null,
        isIndividualAccount: null,
        notes: null,
        accountDisplayId: null,
        isConvertedCustomer: false,
        isRfqAccount: false,
        accountDetails: {
            customerDetailsId: null,
            leadSourceId: null,
            assignedTo: null,
            assignedToId: null,
            industryId: null,
            accountStatusId: null,
            leadSourcePrimaryId: null,
            industryPrimaryId: null,
        },
        contact: {
            accountId: null,
            contactId: null,
        },
        address: {
            accountId: null,
            addressId: null,
        },
    };

    statusUpdateModel = {
        accountId: null,
        isActive: null
    };

    bulkStatusUpdateModel = {
        isActive: null,
        accountId: []
    };

    customerDetailsModel = {
        accountName: null,
        industryName: null,
        lastActive: null,
        leadSourceName: null,
        createdBy: null,
        createdOn: null,
        accountType: null,
        stageStatus: null,
        activeStatus: null,
        accountDisplayId: null
    };

    summaryModel = {
        contactsCount: 0,
        addressesCount: 0,
        quotesCount: 0,
        jobsCount: 0,
        associatedJobsCount: 0,
        markupsCount: 0,
        servicesCount: 0,
        popupsCount: 0,
        appointmentsCount: 0,
        documentsCount: 0,
        notesCount: 0,
        boxMapping: 0
    };

    ConvertToFullAccountFormModel = {
        accountId: 0,
        accountName: null,
        isIndividualAccount: '1',
        notes: null,
        accountDetails: {
            leadSourceId: null,
            assignedTo: null,
            industryId: null,
            accountStatusId: 1
        },
        contact: {
            contactId: 0,
            contactTypeId: 1, // TODO
            firstName: null,
            middleName: null,
            lastName: null,
            email: null,
            primaryPhone: null,
            primaryExt: null,
            contactNumberList: []
        },
        address: {
            addressId: 0,
            addressLine1: null,
            addressLine2: null,
            fullAddress: null,
            city: null,
            zipCode: null,
            countryId: null,
            addressIndicator: '1',
            customeAddressTypeInfo: null,
            addressTypeId: 1, // TODO
        },
    };

    accountDetails = { accountName: null, isIndividualAccount: null };

    getFilters(response?: any): object {
        return [
            { routerLink: 'all-accounts', text: 'All Accounts', count: response ? response.totalResults : 0 },
            { routerLink: 'added-in-last', text: 'Added in Last 7 days', count: 0 },
            // { routerLink: 'accessed-in-last', text: 'Accessed in Last 7 days', count: 0 },
            { routerLink: 'modified-in-last', text: 'Modified in Last 7 days', count: 0 },
            // { routerLink: 'inactive', text: 'Inactive for one year', count: 0 },
            { routerLink: 'quotes', text: 'With Quotes', count: 0 },
            // { routerLink: 'pending-invoices', text: 'With Pending Invoices  ', count: 0 },
            // { routerLink: 'deactivated', text: 'Deactivated ', count: 0 },
            { routerLink: 'active-jobs', text: 'With Active Jobs', count: 0 },
        ];
    }

    getFiltersLinks() {
        return {
            All: { label: 'All', link: 'all-accounts'},
            AddedInSevenDays: { label: 'Added In 7 Days', link: 'added-in-last'},
            ModifiedInSevenDays: { label: 'Modified In 7 Days', link: 'modified-in-last'},
            WithQuotes: { label: 'With Quotes', link: 'quotes'},
            WithActiveJobs: { label: 'With Active Jobs', link: 'active-jobs'}
        };
    }

}
